// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + "ad1f5ef47b9806db2c11" + ".bundle.js";
};